import { render, staticRenderFns } from "./ParallelWrapNode.vue?vue&type=template&id=04a77b73&scoped=true&"
import script from "./ParallelWrapNode.vue?vue&type=script&lang=js&"
export * from "./ParallelWrapNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a77b73",
  null
  
)

export default component.exports